module.exports = __webpack_public_path__ + "static/img/Soapstone.18bd846.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Soapstone.jpg
// module id = P2Dl
// module chunks = 0